import styled from 'styled-components';

import { Colors } from 'environment';

export const ActionCell = styled.span`
	color: ${Colors.primary.normal};
	cursor: pointer;
`;
